import { render, staticRenderFns } from "./HotelTravellersCollapse.vue?vue&type=template&id=9453e73e&scoped=true&"
import script from "./HotelTravellersCollapse.vue?vue&type=script&lang=js&"
export * from "./HotelTravellersCollapse.vue?vue&type=script&lang=js&"
import style0 from "./HotelTravellersCollapse.vue?vue&type=style&index=0&id=9453e73e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9453e73e",
  null
  
)

export default component.exports